import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays, CheckCircle2, ShieldCheck, Sparkles, UserCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

export const HowItWorksStrip = () => {
  const { openAuthModal } = useAuth();

  const steps = [
    {
      number: "01",
      icon: UserCheck,
      title: "Verifica tu perfil una sola vez",
      desc: "Documento oficial y biometría para que toda la comunidad comparta con tranquilidad. Sin cuotas de membresía ni permanencias.",
    },
    {
      number: "02",
      icon: CalendarDays,
      title: "Elige fechas y precio transparente",
      desc: "Alquila por días o semanas con precios fijados por el propietario y 1 € fijo de gestión. Añade fianza opcional con garantía Swikly.",
    },
    {
      number: "03",
      icon: CheckCircle2,
      title: "Entrega en mano o envío",
      desc: "Queda gratis con tu vecino para entrega en mano o recíbelo en tu punto de recogida SendCloud / InPost.",
    },
    {
      number: "04",
      icon: ShieldCheck,
      title: "Monta, disfruta y devuelve",
      desc: "Inspección fotográfica previa y posterior. Cuando el propietario confirma la devolución en perfecto estado, la fianza se libera al instante.",
    },
  ];

  return (
    <section
      data-section="how-it-works-strip"
      className="py-16 lg:py-24 bg-white dark:bg-card border-b border-stone-200/60 dark:border-border"
    >
      <div className="container mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-12 sm:mb-16">
          <p className="text-xs uppercase font-bold tracking-widest text-primary mb-3">
            Paso a paso sencillo
          </p>
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-stone-900 dark:text-foreground tracking-tight">
            Cómo funciona el alquiler de LEGO® entre vecinos
          </h2>
          <p className="mt-3 text-base sm:text-lg text-stone-600 dark:text-muted-foreground">
            Un marketplace transparente: sin suscripciones obligatorias, pagando solo por el tiempo que disfrutas cada set.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {steps.map((step) => {
            const Icon = step.icon;
            return (
              <div
                key={step.number}
                className="relative p-6 rounded-2xl bg-[#FAF8F5] dark:bg-background border border-stone-200/70 dark:border-border flex flex-col justify-between"
              >
                <div>
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-2xl font-display font-black text-primary/40">
                      {step.number}
                    </span>
                    <div className="p-2 rounded-xl bg-white dark:bg-card shadow-xs border border-stone-200/60 dark:border-border">
                      <Icon className="h-5 w-5 text-primary" />
                    </div>
                  </div>
                  <h3 className="text-lg font-bold text-stone-900 dark:text-foreground mb-2">
                    {step.title}
                  </h3>
                  <p className="text-sm text-stone-600 dark:text-muted-foreground leading-relaxed">
                    {step.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Banner de llamada a la acción */}
        <div className="mt-12 sm:mt-16 p-8 rounded-3xl bg-stone-900 text-white flex flex-col sm:flex-row items-center justify-between gap-6 shadow-xl">
          <div className="space-y-2 text-center sm:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-stone-800 text-emerald-400 text-xs font-semibold">
              <Sparkles className="h-3.5 w-3.5" />
              <span>Comunidad de proximidad</span>
            </div>
            <h3 className="text-2xl font-bold font-display">
              ¿Tienes sets guardados en cajas o estanterías?
            </h3>
            <p className="text-stone-400 text-sm max-w-xl">
              Publícalos en minutos, ponles tu tarifa diaria o semanal y genera ingresos compartiéndolos con otros aficionados de tu ciudad.
            </p>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            <Button
              size="lg"
              className="rounded-full bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-6"
              onClick={() => openAuthModal("signup")}
            >
              Empezar ahora
              <ArrowRight className="h-4 w-4 ml-2" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksStrip;
